import { render } from "./UserRoleProfilePicker.vue?vue&type=template&id=006ec028&scoped=true&ts=true"
import script from "./UserRoleProfilePicker.vue?vue&type=script&lang=ts"
export * from "./UserRoleProfilePicker.vue?vue&type=script&lang=ts"

import "./UserRoleProfilePicker.vue?vue&type=style&index=0&id=006ec028&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006ec028"]])

export default __exports__